// extracted by mini-css-extract-plugin
module.exports = {"commonStyles":"Icons__commonStyles___3mnSK"};